import { usePrototypeViewContext } from './usePrototypeViewContext'

/**
 * Returns the very first artboard id used by the user to enter the prototype.
 */
export function useInitialPrototypeArtboardId() {
  const context = usePrototypeViewContext()
  return context.initialArtboardId
}
